// AGORA — design tokens (généré par scripts/jetons.mjs depuis tokens.json : ne pas modifier à la main)
export const tokens = {
  "name": "AGORA",
  "version": 1,
  "color": {
    "themes": [
      {
        "id": "light",
        "name": "Clair"
      },
      {
        "id": "dark",
        "name": "Sombre"
      }
    ],
    "tokens": [
      {
        "name": "surface-000",
        "value": {
          "light": "#eef3f2",
          "dark": "#071315"
        },
        "usage": "Fond de page sous le canevas d'ambiance et les couches de verre."
      },
      {
        "name": "canvas-1",
        "value": {
          "light": "rgba(28,70,76,0.34)",
          "dark": "rgba(81,182,143,0.24)"
        },
        "usage": "Halo d'ambiance pétrole (clair) / jade (sombre) du canevas — ce que le verre réfracte."
      },
      {
        "name": "canvas-2",
        "value": {
          "light": "rgba(81,182,143,0.42)",
          "dark": "rgba(28,110,120,0.42)"
        },
        "usage": "Halo d'ambiance jade (clair) / pétrole profond (sombre) du canevas."
      },
      {
        "name": "canvas-3",
        "value": {
          "light": "rgba(129,187,39,0.30)",
          "dark": "rgba(129,187,39,0.16)"
        },
        "usage": "Halo d'ambiance lime, petit et discret, du canevas."
      },
      {
        "name": "glass",
        "value": {
          "light": "rgba(255,255,255,0.42)",
          "dark": "rgba(14,38,42,0.42)"
        },
        "usage": "Liquid Glass standard : dock de navigation, en-tête, boutons flottants — toujours avec flou (blur 28px saturate 190%)."
      },
      {
        "name": "glass-card",
        "value": {
          "light": "rgba(255,255,255,0.58)",
          "dark": "rgba(16,40,44,0.52)"
        },
        "usage": "Verre des cartes, panneaux, tuiles KPI posés sur le canevas."
      },
      {
        "name": "glass-strong",
        "value": {
          "light": "rgba(255,255,255,0.78)",
          "dark": "rgba(10,28,31,0.78)"
        },
        "usage": "Verre dense : feuilles modales, menus, tableaux de données, verre sur contenu chargé."
      },
      {
        "name": "glass-stroke",
        "value": {
          "light": "rgba(255,255,255,0.85)",
          "dark": "rgba(255,255,255,0.16)"
        },
        "usage": "Liseré intérieur 1px en haut des couches de verre (reflet spéculaire)."
      },
      {
        "name": "glass-edge",
        "value": {
          "light": "rgba(16,42,46,0.12)",
          "dark": "rgba(0,0,0,0.50)"
        },
        "usage": "Contour extérieur 0.5px des couches de verre, les détache du fond."
      },
      {
        "name": "glass-selected",
        "value": {
          "light": "rgba(28,70,76,0.12)",
          "dark": "rgba(95,196,156,0.20)"
        },
        "usage": "Pastille de l'onglet actif dans le dock en verre."
      },
      {
        "name": "surface-100",
        "value": {
          "light": "#ffffff",
          "dark": "#0e1f22"
        },
        "usage": "Repli opaque du verre ; champs de saisie ; cellules de tableau."
      },
      {
        "name": "surface-200",
        "value": {
          "light": "#e3ebea",
          "dark": "#162b2e"
        },
        "usage": "Survol de ligne, zones secondaires, en-têtes de tableau."
      },
      {
        "name": "surface-300",
        "value": {
          "light": "#d4e0de",
          "dark": "#293137"
        },
        "usage": "Sélection de ligne, élément actif d'une liste."
      },
      {
        "name": "border",
        "value": {
          "light": "#cbd8d6",
          "dark": "#284346"
        },
        "usage": "Séparateurs et contours décoratifs (non porteurs de sens)."
      },
      {
        "name": "border-strong",
        "value": {
          "light": "#6f8789",
          "dark": "#62807f"
        },
        "usage": "Contour des contrôles (champs, cases, boutons secondaires) — 3:1 sur toutes les surfaces."
      },
      {
        "name": "ink",
        "value": {
          "light": "#0f2a2e",
          "dark": "#e4eeec"
        },
        "usage": "Texte principal sur surface-000 à surface-300, sur le canevas et sur tous les verres."
      },
      {
        "name": "ink-muted",
        "value": {
          "light": "#47605f",
          "dark": "#9db5b3"
        },
        "usage": "Texte secondaire, métadonnées, onglets inactifs sur surface-000 à surface-200 et sur glass-card / glass-strong."
      },
      {
        "name": "brand",
        "value": {
          "light": "#1c464c",
          "dark": "#5fc49c"
        },
        "usage": "Pétrole PRODEVAL (sombre : jade) : action principale, lien, onglet actif, progression."
      },
      {
        "name": "on-brand",
        "value": {
          "light": "#ffffff",
          "dark": "#04241b"
        },
        "usage": "Texte et icônes posés sur un aplat brand."
      },
      {
        "name": "brand-subtle",
        "value": {
          "light": "#e0eeeb",
          "dark": "#123a35"
        },
        "usage": "Fond d'un élément sélectionné ou mis en avant (filtre actif, chip)."
      },
      {
        "name": "brand-ink",
        "value": {
          "light": "#1c464c",
          "dark": "#8fdcbd"
        },
        "usage": "Texte de lien, onglet actif, texte sur brand-subtle, surface-000, surface-100."
      },
      {
        "name": "jade",
        "value": {
          "light": "#51b68f",
          "dark": "#5fc49c"
        },
        "usage": "Jade PRODEVAL : accent secondaire décoratif (barres de progression, illustrations, couverture). Jamais du texte sur clair."
      },
      {
        "name": "lime",
        "value": {
          "light": "#81bb27",
          "dark": "#9ccf45"
        },
        "usage": "Lime PRODEVAL — la flamme du logo : ligne « aujourd'hui » du planning, jalons, indicateur de nouveauté. Jamais du texte ; en petite dose."
      },
      {
        "name": "view-custom",
        "value": {
          "light": "#1e7a52",
          "dark": "#7fdcb4"
        },
        "usage": "Vue personnalisée : engrenage d'un tableau dont colonnes, tri ou filtres diffèrent de la vue par défaut de l'utilisateur — icône et pastille, 3:1 sur toutes les surfaces."
      },
      {
        "name": "view-custom-subtle",
        "value": {
          "light": "#dcf2e7",
          "dark": "#15392b"
        },
        "usage": "Fond de l'engrenage en vue personnalisée."
      },
      {
        "name": "focus-ring",
        "value": {
          "light": "#1c464c",
          "dark": "#8fdcbd"
        },
        "usage": "Anneau de focus clavier : 2px plein, décalé de 2px — 3:1 sur toutes les surfaces."
      },
      {
        "name": "status-info",
        "value": {
          "light": "#1d58a8",
          "dark": "#8ab6ff"
        },
        "usage": "Statut Ouvert / Nouveau : texte et icône sur status-info-subtle et surface-100."
      },
      {
        "name": "status-info-subtle",
        "value": {
          "light": "#e3edfa",
          "dark": "#142846"
        },
        "usage": "Fond de badge Ouvert / Nouveau."
      },
      {
        "name": "status-progress",
        "value": {
          "light": "#5a46a0",
          "dark": "#b9a8f3"
        },
        "usage": "Statut En cours : texte et icône sur status-progress-subtle et surface-100."
      },
      {
        "name": "status-progress-subtle",
        "value": {
          "light": "#eeeafa",
          "dark": "#272046"
        },
        "usage": "Fond de badge En cours."
      },
      {
        "name": "status-waiting",
        "value": {
          "light": "#7a4f00",
          "dark": "#f0c060"
        },
        "usage": "Statut En attente / Bloqué / Avertissement : texte sur status-waiting-subtle et surface-100."
      },
      {
        "name": "status-waiting-subtle",
        "value": {
          "light": "#fbefd5",
          "dark": "#3a2c0c"
        },
        "usage": "Fond de badge En attente, bandeau d'avertissement."
      },
      {
        "name": "status-success",
        "value": {
          "light": "#1f6a40",
          "dark": "#7fd3a0"
        },
        "usage": "Statut Terminé / Conforme / Clôturé : texte sur status-success-subtle et surface-100."
      },
      {
        "name": "status-success-subtle",
        "value": {
          "light": "#e1f2e7",
          "dark": "#133423"
        },
        "usage": "Fond de badge Terminé / Conforme."
      },
      {
        "name": "status-danger",
        "value": {
          "light": "#ad2a20",
          "dark": "#ff9384"
        },
        "usage": "Statut En retard / Non conforme / Erreur : texte sur status-danger-subtle et surface-100."
      },
      {
        "name": "status-danger-subtle",
        "value": {
          "light": "#fae6e3",
          "dark": "#3d1714"
        },
        "usage": "Fond de badge En retard, bandeau d'erreur."
      },
      {
        "name": "status-neutral",
        "value": {
          "light": "#47605f",
          "dark": "#9db5b3"
        },
        "usage": "Statut Brouillon / Annulé : texte sur status-neutral-subtle et surface-100."
      },
      {
        "name": "status-neutral-subtle",
        "value": {
          "light": "#e3ebea",
          "dark": "#1f3336"
        },
        "usage": "Fond de badge Brouillon / Annulé."
      },
      {
        "name": "danger",
        "value": {
          "light": "#ad2a20",
          "dark": "#ff9384"
        },
        "usage": "Aplat du bouton destructif (supprimer, rejeter)."
      },
      {
        "name": "on-danger",
        "value": {
          "light": "#ffffff",
          "dark": "#3a0904"
        },
        "usage": "Texte sur un aplat danger."
      },
      {
        "name": "metier-service",
        "value": {
          "light": "#2f5a86",
          "dark": "#86b4e4"
        },
        "usage": "Métier Service (acier) — GMAO, Field Service, Hotline : pastille, barres de planning, événements."
      },
      {
        "name": "metier-etude",
        "value": {
          "light": "#5b4a9e",
          "dark": "#ab9cf0"
        },
        "usage": "Métier Étude (iris) — R&D, Projection, Méthode : pastille, barres de planning, événements."
      },
      {
        "name": "metier-commerce",
        "value": {
          "light": "#9a3858",
          "dark": "#ee93b2"
        },
        "usage": "Métier Commerce (framboise) — Prospection, Vente, Après-vente : pastille, barres, événements."
      },
      {
        "name": "metier-mes",
        "value": {
          "light": "#1f6f73",
          "dark": "#6cc9cc"
        },
        "usage": "Métier Mise en service (sarcelle) — Gestion de projet, Essais & réception : pastille, barres de planning, événements."
      },
      {
        "name": "metier-qhse",
        "value": {
          "light": "#9a5e00",
          "dark": "#e8b350"
        },
        "usage": "Métier QHSE (ambre sécurité) — événements, NC, audits, actions, risques : pastille, barres, événements."
      },
      {
        "name": "metier-achats",
        "value": {
          "light": "#843a7e",
          "dark": "#e7a6e4"
        },
        "usage": "Métier Achats (prune) — fournisseurs, appro projets, pièces SAV, support et moyens généraux : pastille, barres, événements."
      },
      {
        "name": "metier-finance",
        "value": {
          "light": "#5e6418",
          "dark": "#cdd27a"
        },
        "usage": "Métier Finance (olive) — contrôle de gestion, clients, fournisseurs, trésorerie, comptabilité : pastille, barres, événements."
      },
      {
        "name": "metier-it",
        "value": {
          "light": "#4f5d6b",
          "dark": "#a9b8c6"
        },
        "usage": "Métier IT (ardoise) — demandes, incidents, parc, changements : pastille, barres, événements."
      },
      {
        "name": "risk-1",
        "value": {
          "light": "#d3ebd9",
          "dark": "#1f4a2b"
        },
        "usage": "Matrice de risque — niveau faible (texte ink)."
      },
      {
        "name": "risk-2",
        "value": {
          "light": "#f6e2a6",
          "dark": "#5a4710"
        },
        "usage": "Matrice de risque — niveau modéré (texte ink)."
      },
      {
        "name": "risk-3",
        "value": {
          "light": "#f4b27a",
          "dark": "#8a4512"
        },
        "usage": "Matrice de risque — niveau élevé (texte ink)."
      },
      {
        "name": "risk-4",
        "value": {
          "light": "#ad2a20",
          "dark": "#e0604f"
        },
        "usage": "Matrice de risque — niveau critique (texte on-risk-4)."
      },
      {
        "name": "on-risk-4",
        "value": {
          "light": "#ffffff",
          "dark": "#1a0503"
        },
        "usage": "Texte sur une case risk-4."
      }
    ]
  },
  "type": {
    "fonts": [],
    "families": {
      "sans": "-apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"IBM Plex Sans\", \"Noto Sans\", \"Segoe UI\", system-ui, sans-serif",
      "mono": "\"IBM Plex Mono\", \"Noto Sans Mono\", ui-monospace, Consolas, monospace"
    },
    "groups": [
      {
        "name": "Titres",
        "family": "sans",
        "styles": [
          {
            "name": "display",
            "fontSize": "34px",
            "lineHeight": "41px",
            "fontWeight": 700,
            "letterSpacing": "-0.02em",
            "usage": "Grand titre iOS (large title) en haut d'écran, titre de page d'accueil d'un module, valeur KPI héros.",
            "sample": "Planning des interventions"
          },
          {
            "name": "h1",
            "fontSize": "24px",
            "lineHeight": "32px",
            "fontWeight": 600,
            "usage": "Titre d'écran (une fois par écran).",
            "sample": "Ordres de travail — Site de Lyon"
          },
          {
            "name": "h2",
            "fontSize": "18px",
            "lineHeight": "26px",
            "fontWeight": 600,
            "usage": "Titre de section ou de panneau.",
            "sample": "Pièces consommées"
          },
          {
            "name": "h3",
            "fontSize": "15px",
            "lineHeight": "22px",
            "fontWeight": 600,
            "usage": "Titre de carte, en-tête de groupe dans une liste.",
            "sample": "INC-2026-004217 · Imprimante hors ligne"
          }
        ]
      },
      {
        "name": "Texte",
        "family": "sans",
        "styles": [
          {
            "name": "body",
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": 400,
            "usage": "Texte courant, cellules de tableau, champs.",
            "sample": "L'intervention est planifiée le 21/10/2026 à 08:30 (heure locale du site)."
          },
          {
            "name": "body-strong",
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": 600,
            "usage": "Valeur mise en avant dans un texte, libellé de bouton.",
            "sample": "Clôturer l'OT"
          },
          {
            "name": "small",
            "fontSize": "13px",
            "lineHeight": "18px",
            "fontWeight": 400,
            "usage": "Métadonnées, aide de champ, horodatage.",
            "sample": "Modifié par M. Rossi · il y a 2 h"
          },
          {
            "name": "overline",
            "fontSize": "11px",
            "lineHeight": "16px",
            "fontWeight": 500,
            "letterSpacing": "0.18em",
            "textTransform": "uppercase",
            "usage": "Sur-titre en capitales très espacées, comme la signature du logo : nom de module au-dessus d'un titre, rubrique.",
            "sample": "INGÉNIERIE DES SOLUTIONS GAZ"
          },
          {
            "name": "label",
            "fontSize": "12px",
            "lineHeight": "16px",
            "fontWeight": 500,
            "letterSpacing": "0.02em",
            "usage": "Libellé de badge, en-tête de colonne, onglet compact.",
            "sample": "EN RETARD"
          },
          {
            "name": "field-body",
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": 400,
            "usage": "Texte courant en usage terrain (tablette, smartphone) — lisible en extérieur.",
            "sample": "Remplacer le joint de la pompe P-104"
          }
        ]
      },
      {
        "name": "Données",
        "family": "mono",
        "styles": [
          {
            "name": "code",
            "fontSize": "13px",
            "lineHeight": "18px",
            "fontWeight": 500,
            "usage": "Références (ticket, OT, équipement, n° de série), codes, chiffres alignés.",
            "sample": "OT-FR01-2026-008841"
          },
          {
            "name": "numeric",
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": 500,
            "usage": "Valeur de KPI, compteur, durée.",
            "sample": "98,4 %"
          }
        ]
      }
    ]
  },
  "spacing": {
    "tokens": [
      {
        "name": "space-1",
        "value": "4px",
        "usage": "Écart icône–libellé, padding vertical de badge."
      },
      {
        "name": "space-2",
        "value": "8px",
        "usage": "Écart entre contrôles groupés, padding de chip."
      },
      {
        "name": "space-3",
        "value": "12px",
        "usage": "Padding de cellule de tableau, padding horizontal de bouton."
      },
      {
        "name": "space-4",
        "value": "16px",
        "usage": "Padding de carte, gouttière mobile."
      },
      {
        "name": "space-5",
        "value": "24px",
        "usage": "Écart entre sections d'un panneau, gouttière desktop."
      },
      {
        "name": "space-6",
        "value": "32px",
        "usage": "Écart entre blocs de page."
      },
      {
        "name": "space-7",
        "value": "48px",
        "usage": "Marges d'écrans vides, en-têtes de page."
      }
    ]
  },
  "radius": {
    "tokens": [
      {
        "name": "radius-sm",
        "value": "8px",
        "usage": "Badges, chips, barres Gantt, cases de matrice."
      },
      {
        "name": "radius-md",
        "value": "14px",
        "usage": "Champs, menus, boutons rectangulaires."
      },
      {
        "name": "radius-lg",
        "value": "18px",
        "usage": "Cartes, panneaux, tuiles KPI."
      },
      {
        "name": "radius-xl",
        "value": "32px",
        "usage": "Barre de navigation flottante, feuilles modales, en-tête en verre."
      },
      {
        "name": "radius-pill",
        "value": "999px",
        "usage": "Boutons (capsule), pastilles de module, sélecteurs, compteurs."
      }
    ]
  },
  "shadow": {
    "tokens": [
      {
        "name": "shadow-1",
        "value": {
          "light": "0 1px 2px rgba(16,42,46,0.06), 0 4px 14px rgba(16,42,46,0.06)",
          "dark": "0 1px 2px rgba(0,0,0,0.5)"
        },
        "usage": "Cartes en verre posées sur le canevas."
      },
      {
        "name": "shadow-2",
        "value": {
          "light": "0 8px 24px rgba(16,42,46,0.14)",
          "dark": "0 8px 24px rgba(0,0,0,0.6)"
        },
        "usage": "Menus déroulants, popovers, modales."
      },
      {
        "name": "shadow-glass",
        "value": {
          "light": "0 12px 36px rgba(16,42,46,0.16)",
          "dark": "0 12px 34px rgba(0,0,0,0.55)"
        },
        "usage": "Ombre portée des couches de verre flottantes (barre de navigation, en-tête)."
      }
    ]
  },
  "size": {
    "tokens": [
      {
        "name": "control-sm",
        "value": "28px",
        "usage": "Hauteur des contrôles dans les tableaux denses."
      },
      {
        "name": "control-md",
        "value": "36px",
        "usage": "Hauteur par défaut des boutons et champs (desktop)."
      },
      {
        "name": "control-field",
        "value": "44px",
        "usage": "Hauteur des champs de saisie (TextField, SelectField, Combobox, liste du formulaire) – 44 px, confortable à la souris comme au doigt."
      },
      {
        "name": "control-touch",
        "value": "48px",
        "usage": "Hauteur minimale des cibles tactiles (app terrain, gants)."
      },
      {
        "name": "sidebar-width",
        "value": "248px",
        "usage": "Largeur de la navigation latérale Métiers › Modules (desktop)."
      },
      {
        "name": "tabbar-height",
        "value": "64px",
        "usage": "Hauteur du dock flottant en bas d'écran."
      },
      {
        "name": "tabbar-inset",
        "value": "12px",
        "usage": "Marge entre le dock flottant et le bas de l'écran (plus la zone de sécurité)."
      }
    ]
  },
  "motion": {
    "reducedMotion": "0.01ms",
    "tokens": [
      {
        "name": "duration-short",
        "value": "150ms",
        "usage": "Retour immédiat sur un petit élément : survol, appui, couleur, icône qui apparaît, message qui disparaît."
      },
      {
        "name": "duration-medium",
        "value": "200ms",
        "usage": "Changement d'état d'un composant : pastille d'un choix segmenté, interrupteur, menu ou fenêtre qui s'ouvre, changement d'écran dans une page."
      },
      {
        "name": "duration-long",
        "value": "320ms",
        "usage": "Déplacement d'une grande surface : sous-menu de la barre latérale qui se déplie, nouvelle page qui apparaît. Une durée plus longue reste exceptionnelle et justifiée dans le code (page qui rejoint le dock)."
      },
      {
        "name": "ease-standard",
        "value": "cubic-bezier(0.25, 0.1, 0.25, 1)",
        "usage": "Changement sur place (couleur, fond, largeur, rotation) d'un élément qui reste à l'écran."
      },
      {
        "name": "ease-enter",
        "value": "cubic-bezier(0.2, 0.8, 0.2, 1)",
        "usage": "Entrée ou arrivée : rapide au départ puis décélérée (élément qui apparaît, pastille qui glisse jusqu'à sa place)."
      },
      {
        "name": "ease-exit",
        "value": "cubic-bezier(0.42, 0, 1, 1)",
        "usage": "Sortie : lente au départ puis accélérée (élément qui disparaît ou quitte l'écran), avec duration-short."
      }
    ]
  },
  "blur": {
    "tokens": [
      {
        "name": "blur-sm",
        "value": "20px",
        "usage": "Petite étiquette en verre posée sur une photo (actualité de la connexion)."
      },
      {
        "name": "blur-md",
        "value": "28px",
        "usage": "Verre de l'habillage : dock, en-tête, barre latérale, barre d'une page côte à côte, menus, fenêtres, messages éphémères ; carte posée sur une photo. Le flou est réservé à l'habillage : jamais sur une carte, une ligne de liste, un tableau, un champ ou un bouton du contenu."
      },
      {
        "name": "blur-lg",
        "value": "34px",
        "usage": "Verre « liquide » des panneaux qui sortent du dock (pages ouvertes, assistant, modules, profil) et de leur pointe."
      }
    ]
  },
  "layer": {
    "tokens": [
      {
        "name": "z-behind",
        "value": "-1",
        "usage": "Décor placé derrière le contenu de son composant (photo de l'actualité)."
      },
      {
        "name": "z-raised",
        "value": "1",
        "usage": "Élément posé au-dessus de ses voisins dans un même composant : colonne figée d'un tableau, étape d'un suivi, pointe d'un panneau."
      },
      {
        "name": "z-sticky",
        "value": "5",
        "usage": "Barre collante du contenu (barre d'une page côte à côte) et panneau des réglages d'un tableau."
      },
      {
        "name": "z-dropdown",
        "value": "20",
        "usage": "Menu ou liste ancré dans le contenu (langues de la connexion, catalogue des cartes de l'accueil) ; carte de l'accueil dont les réglages sont ouverts."
      },
      {
        "name": "z-popover",
        "value": "30",
        "usage": "Panneau ancré (réglages d'une carte, liste avec recherche, panneau d'un bouton du dock), carte saisie de l'accueil, bandeau d'environnement."
      },
      {
        "name": "z-dock",
        "value": "40",
        "usage": "Dock flottant du bas de l'écran : au-dessus de tout le contenu des pages."
      },
      {
        "name": "z-flyout",
        "value": "50",
        "usage": "Menu de l'habillage qui passe au-dessus du dock (filiales de l'en-tête), copie animée d'une page vers le dock."
      },
      {
        "name": "z-modal",
        "value": "60",
        "usage": "Voile des fenêtres modales et de la recherche (Ctrl K)."
      },
      {
        "name": "z-toast",
        "value": "70",
        "usage": "Messages éphémères : toujours au premier plan."
      }
    ]
  }
} as const;
export type ColorToken = 'surface-000' | 'canvas-1' | 'canvas-2' | 'canvas-3' | 'glass' | 'glass-card' | 'glass-strong' | 'glass-stroke' | 'glass-edge' | 'glass-selected' | 'surface-100' | 'surface-200' | 'surface-300' | 'border' | 'border-strong' | 'ink' | 'ink-muted' | 'brand' | 'on-brand' | 'brand-subtle' | 'brand-ink' | 'jade' | 'lime' | 'view-custom' | 'view-custom-subtle' | 'focus-ring' | 'status-info' | 'status-info-subtle' | 'status-progress' | 'status-progress-subtle' | 'status-waiting' | 'status-waiting-subtle' | 'status-success' | 'status-success-subtle' | 'status-danger' | 'status-danger-subtle' | 'status-neutral' | 'status-neutral-subtle' | 'danger' | 'on-danger' | 'metier-service' | 'metier-etude' | 'metier-commerce' | 'metier-mes' | 'metier-qhse' | 'metier-achats' | 'metier-finance' | 'metier-it' | 'risk-1' | 'risk-2' | 'risk-3' | 'risk-4' | 'on-risk-4';
/** Mouvement pour les animations en JavaScript (Motion) : durées en millisecondes, courbes en points de cubic-bezier. */
export const motionTokens = {
  duration: { short: 150, medium: 200, long: 320 },
  ease: { standard: [0.25, 0.1, 0.25, 1], enter: [0.2, 0.8, 0.2, 1], exit: [0.42, 0, 1, 1] },
} as const;
